import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../components/PageTitle/PageTitle";


// data

import {ClerkList} from "./clerkList-api"
import auth from "../../auth/auth-helper";

const columns = [
  {
   name: "first_name",
   label: "First Name",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "last_name",
   label: "Last Name",
  },
  {
    name: "nic",
    label: "NIC No",
   },
  {
   name: "dob",
   label: "DOB",
  },
  {
    name: "employee_id",
    label: "ID",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "address",
    label: "Address",
   },
  
  {
   name: "status",
   label: "Status",
   options: {
    filter: true,
    sort: false,
   }
  },
 ];

export default function Clerks() {
  
  const [clerks, setClerks] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    ClerkList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        // console.log(res.statusCode);
        setClerks(res.response[0]);
      } else {
       
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Clerks" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Clerks List"
            data={clerks}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}